import { ReactNode } from 'react'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { Col, Row } from '@/shared/ui/Grid'

import styles from './HorizontalSection.module.scss'

export type HorizontalSectionProps = {
	title?: string
	titlePosition?: `center` | `start` | `end`
	subtitle?: string
	centerTitle?: boolean
	id?: string
	borderNone?: boolean
	infoContentMargin?: string
	children?: ReactNode
}

/** A component that displays a title and subtitle on the left and content on the right.
 * @param props
 * @param props.title
 * @param props.titlePosition
 * @param props.subtitle
 * @param props.centerTitle
 * @param props.children
 * @param props.id
 * @param props.borderNone
 * @param props.infoContentMargin
 * */
export const HorizontalSection = ({
	title,
	titlePosition = `start`,
	subtitle,
	centerTitle,
	children,
	id = ``,
	borderNone,
	infoContentMargin
}: HorizontalSectionProps): JSX.Element => (
	<section id={id} className={`${styles.horizontalSection} ${borderNone ? styles.borderNone : ''}`}>
		<Row>
			<Col lg={12} xs={24}>
				<div
					className={`${styles.titleBlock} ${centerTitle ? styles.center : ''}`}
					style={{ margin: infoContentMargin }}>
					{!!title && (
						<p
							className={styles.title}
							style={{ textAlign: titlePosition }}
							dangerouslySetInnerHTML={createMarkup(title)}
						/>
					)}
					{subtitle && <p className={styles.subtitle} dangerouslySetInnerHTML={createMarkup(subtitle)} />}
				</div>
			</Col>
			<Col lg={12} xs={24}>
				{children}
			</Col>
		</Row>
	</section>
)
